import arrowupSvg from './images/arrow-up.svg';
import swapSvg from './images/swap.svg';
import ascending from './images/ascending-sort.svg';
import { AddDataModal } from './AddDataModal';
import styled from 'styled-components';

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: stretch;
`;

function StackColumnButtons(props) {
  return <Buttons>
    <button type="button" className="btn btn-primary w-100" data-cy="pop-to-top-btn" onClick={props.moveLastToTop}>
      <img src={arrowupSvg} alt={"moveToTop"} />
    </button>
    <button type="button" className="btn btn-primary w-100" data-cy="shuffle-btn" onClick={props.shuffleTasks}>
      <img src={swapSvg} alt={"shuffle"} />
    </button>
    <button type="button" className="btn btn-primary w-100" data-cy="sort_by_completion_time" onClick={props.sortByCompletionTime}>
      <img src={ascending} alt={"sort-ascending"} />
    </button>
    <AddDataModal addTaskToStack={props.addTaskToStack} />
    <p className="w-100" data-cy="timeleft">time left:<br /> {props.timeleft}</p>
  </Buttons>;
}

export { StackColumnButtons };
